import React from "react";
import { NavigationItem } from "@design-system/Navigation/NavigationItem";
import { NavigationMenu } from "@design-system/Navigation/NavigationMenu";
import { BusinessIcon, TasksIcon, TemplatesIcon } from "@icons";
import { useTypedFlags } from "@hooks/useTypedFlags";
import { OrganizationSettingsPages } from "./constants";
import { SettingsNavLink } from "./SettingsNavLink";

export const OrganizationSettingsNavigation: React.FC = () => {
    const { closeManagement } = useTypedFlags();

    return (
        <>
            <header className="settings__navigation__workspaces-header">
                Firm
            </header>

            <NavigationMenu className="flex-column">
                <SettingsNavLink
                    eventKey={OrganizationSettingsPages.FIRM_INFORMATION}
                >
                    <NavigationItem icon={<BusinessIcon />}>
                        Profile
                    </NavigationItem>
                </SettingsNavLink>

                <SettingsNavLink
                    eventKey={OrganizationSettingsPages.TASK_GROUPS}
                >
                    <NavigationItem icon={<TasksIcon />}>
                        Task groups
                    </NavigationItem>
                </SettingsNavLink>

                {closeManagement && (
                    <SettingsNavLink
                        eventKey={OrganizationSettingsPages.CLOSES}
                    >
                        <NavigationItem icon={<TemplatesIcon />}>
                            Templates
                        </NavigationItem>
                    </SettingsNavLink>
                )}
            </NavigationMenu>
        </>
    );
};
